import * as React from "react"

import CardExternalLink from "./CardExternalLink"
import CardInternalLink from "./CardInternalLink"
import ExternalLink from "./ExternalLink"

const displayNamePart = (value: string) =>
  value === value.toLowerCase()
    ? value.replace(/\b[a-z]/g, letter => letter.toUpperCase())
    : value

const displayPublisher = (value: string) => {
  if (value !== value.toLowerCase()) return value
  return value
    .replace(/\b[a-z]/g, letter => letter.toUpperCase())
    .replace(/\b(And|Of|The|In|For|To|On|At|A|An)\b/g, (word, offset) =>
      offset === 0 ? word : word.toLowerCase()
    )
}

const PublicationCard = ({
  title,
  subtitle,
  publisher,
  publisherUrl,
  downloadUrl,
  publicationType,
  year,
  authors,
  doi,
  mediaCoverage,
  podcast,
  summaryPath,
}) => {
  const mergedTitle = subtitle ? `${title}: ${subtitle}` : title
  const primaryLink = summaryPath
    ? { kind: "internal", url: summaryPath, label: "Project overview" }
    : downloadUrl
    ? { kind: "external", url: downloadUrl, label: "Download PDF" }
    : publisherUrl
    ? { kind: "external", url: publisherUrl, label: "Publisher page" }
    : null

  return (
    <article className="publication-entry" data-content-type="publication">
      <span className="sr-only" data-field="type">
        {publicationType}
      </span>
      <span className="publication-entry__year" data-field="year">
        {year === 999 ? "In Press" : year}
      </span>
      <div className="publication-entry__body">
        <h3 data-field="title">
          <cite>{mergedTitle}</cite>
        </h3>
        {publisher && (
          <p className="publication-entry__publisher" data-field="publisher">
            {displayPublisher(publisher)}
          </p>
        )}
        <div className="publication-entry__authors" data-field="authors">
          {authors.map((author, index) => {
            const fullName = `${displayNamePart(author.firstName)} ${
              author.middleInitial
                ? `${displayNamePart(author.middleInitial)}. `
                : ""
            }${displayNamePart(author.familyName)}`
            return (
              <React.Fragment key={fullName}>
                {index > 0 && ", "}
                <span
                  className={
                    author.familyName.toLowerCase() === "stothart"
                      ? "publication-entry__author--featured"
                      : undefined
                  }
                >
                  {fullName}
                </span>
              </React.Fragment>
            )
          })}
        </div>
        {mediaCoverage?.length > 0 && (
          <div className="publication-entry__media" data-field="media">
            <span>featured in</span>
            <div>
              {mediaCoverage.map(article => (
                <ExternalLink key={article.url} href={article.url}>
                  {article.publisher}
                </ExternalLink>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="publication-entry__action" data-field="primary-link">
        {primaryLink?.kind === "internal" && (
          <CardInternalLink url={primaryLink.url} label={primaryLink.label} />
        )}
        {primaryLink?.kind === "external" && (
          <CardExternalLink url={primaryLink.url} label={primaryLink.label} />
        )}
      </div>
    </article>
  )
}

export default PublicationCard
